import { Grid, makeStyles, Typography } from '@material-ui/core/';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { toPrice } from '~/utils/format';
import PriceLine from './PriceLine.jsx';
import PriceLineGroup from './PriceLineGroup';

export default PriceLines;

const useStyles = makeStyles((theme) => ({
  priceContainer: {
    padding: 20,
  },
  conained: {
    border: '1px solid',
    borderColor: theme.palette.grey[200],
    backgroundColor: theme.palette.common.white,
    borderRadius: 10,
  },
  priceLineText: {
    flexGrow: 1,
  },
}));

function PriceLines(props) {
  const { variant = 'contained', amountGroups, subTotal, amountDeductions } = props;
  const classes = useStyles();

  if (!amountGroups) {
    return null;
  }

  return (
    <>
      <Grid
        item
        className={classNames([
          classes.priceContainer,
          variant === 'contained' ? classes.conained : null,
        ])}>
        {subTotal && <PriceLine amount={subTotal} />}
        {Object.keys(amountGroups).map((groupName) => {
          if (groupName !== 'null') {
            return (
              <PriceLineGroup
                key={groupName}
                groupName={groupName}
                groupItems={amountGroups[groupName]}
              />
            );
          } else {
            return amountGroups[groupName].map((amount) => (
              <PriceLine key={amount.name} amount={amount} />
            ));
          }
        })}

        {amountDeductions &&
          amountDeductions.map((deduction) => (
            <Grid item key={deduction.id} container alignItems='center'>
              <Grid item className={classes.priceLineText}>
                <Typography> {deduction.attributes.description} </Typography>
              </Grid>
              <Grid item>
                <Typography color='secondary'>
                  {' '}
                  -{toPrice(deduction.attributes.amountApplied)}{' '}
                </Typography>
              </Grid>
            </Grid>
          ))}
      </Grid>
    </>
  );
}

PriceLines.propTypes = {
  variant: PropTypes.oneOf(['contained', 'simple']),
  amountGroups: PropTypes.object,
  subTotal: PropTypes.object,
  amountDeductions: PropTypes.array,
};
